var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{ref:"chart",staticClass:"chart",class:_vm.selectUnit,style:(_vm.selectedRowYear),attrs:{"type":_vm.type,"data":_vm.data,"options":_vm.chartOptions,"resizeDebounce":10},on:{"ready":_vm.onChartReady}})}
var staticRenderFns = []

export { render, staticRenderFns }